'use client';
import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { toast } from 'sonner';
import type { StockPosition } from './StockPositionsContent';

export default function ReorderAlertPanel({ items }: { items: StockPosition[] }) {
  if (items.length === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-5 shadow-card text-center">
        <Icon name="CheckCircleIcon" size={24} className="text-teal mx-auto mb-2" />
        <p className="text-sm font-600 text-foreground">No Reorder Alerts</p>
        <p className="text-xs text-muted-foreground mt-1">All critical items are above reorder levels.</p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-red-200 rounded-xl shadow-card overflow-hidden">
      <div className="px-4 py-3 bg-red-50 border-b border-red-200 flex items-center gap-2">
        <Icon name="ExclamationTriangleIcon" size={15} className="text-red-600" />
        <h3 className="text-sm font-600 text-red-700">Reorder Alerts</h3>
        <span className="ml-auto text-xs bg-red-500 text-white px-2 py-0.5 rounded-full font-600">{items.length}</span>
      </div>
      <div className="divide-y divide-border">
        {items.map((item) => (
          <div key={item.id} className="px-4 py-3">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="min-w-0">
                <p className="text-xs font-600 text-foreground truncate">{item.itemName}</p>
                <p className="text-[11px] text-muted-foreground font-mono-data">{item.itemCode} · {item.site}</p>
              </div>
              {item.health === 'OUT_OF_STOCK' && (
                <span className="text-[10px] bg-red-500 text-white px-1.5 py-0.5 rounded font-700 shrink-0">OUT</span>
              )}
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs text-muted-foreground">Available:</span>
              <span className={`text-xs font-700 tabular-nums ${item.available === 0 ? 'text-red-600' : 'text-amber-600'}`}>
                {item.available} {item.uom}
              </span>
              <span className="text-xs text-muted-foreground">/ Reorder: {item.reorderLevel} {item.uom}</span>
            </div>
            <button
              onClick={() => toast.success(`PO raised for ${item.itemCode}`)}
              className="w-full py-1.5 text-xs font-600 bg-accent text-accent-foreground rounded-md hover:bg-amber-500 transition-all active:scale-95"
            >
              Raise Purchase Order
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}